// App.js
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import TopBar from "./components/TopBar";
import "./customStyles/modals.css";
import { ROUTES } from "./utils/constants";
import girarTablet from "./assets/girar-tablet.png"
import { MediaProvider } from "./contexts/MediaContext";

function App() {
	const location = useLocation();
	const dispatch = useDispatch();

	const noTopBarScreens = [
		ROUTES.HOME,
		ROUTES.REGISTER,
		ROUTES.PRESENTATION,
		ROUTES.START_GAME,
		ROUTES.START_GAME2,
		ROUTES.START_GAME3,
		ROUTES.START_GAME4,
		ROUTES.START_GAME5,
		ROUTES.SCENARIO1_INTRO,
		ROUTES.SCENARIO1_INSTRUCTIONS,
		ROUTES.CONGRATULATIONS,
		ROUTES.END,
		ROUTES.RESULTS,
		ROUTES.GAMEOVER,
		ROUTES.WARMUP,
		ROUTES.FINAL_SCENE
	];
	const showTopBar = !noTopBarScreens.some(
		(x) => location.pathname.toString() === x
	);

	const forceLandscape = true;

	const [isPortrait, setIsPortrait] = useState(() => {
		if (typeof window === "undefined") return false;
		return window.matchMedia("(orientation: portrait)").matches;
	});

	const [isTouchDevice, setIsTouchDevice] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined") return;

		setIsTouchDevice(
			"ontouchstart" in window || navigator.maxTouchPoints > 0
		);

		const mql = window.matchMedia("(orientation: portrait)");
		const onChange = (e) => setIsPortrait(e.matches);

		if (mql.addEventListener) {
			mql.addEventListener("change", onChange);
		} else {
			mql.addListener(onChange);
		}

		// Fallback por si no dispara el change en algún navegador
		const onResize = () =>
			setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
		window.addEventListener("resize", onResize);

		return () => {
			if (mql.removeEventListener) {
				mql.removeEventListener("change", onChange);
			} else {
				mql.removeListener(onChange);
			}
			window.removeEventListener("resize", onResize);
		};
	}, []);

	window.onbeforeunload = function () {
		return "Your work will be lost.";
	};

	const isEscapeRoom = location.pathname === ROUTES.ESCAPE_ROOM;
	return (
		<MediaProvider>
			<div className={`App ${showTopBar ? "" : ""}`}>
				{showTopBar && (
					<div
						className={isEscapeRoom ? "topbar-white-bg" : undefined}
						style={isEscapeRoom ? { position: "relative", zIndex: 100, backgroundColor: "#fff" } : undefined}
					>
						<TopBar />
					</div>
				)}
				<Outlet />
			</div>
			{forceLandscape && isTouchDevice && isPortrait && (
				<div className="d-flex orientation-overlay px-5">
					<img src={girarTablet} style={{maxWidth: "240px"}}/>
					<p className="txtTexto3 ps-5 txtWhite">
						Para una mejor experiencia, use la tablet en{" "}
						<strong>orientación horizontal</strong> durante todo el juego.
					</p>
				</div>
			)}
		</MediaProvider>
	);
}
export default App;
